// frontend/src/services/api.js
import axios from 'axios';

const API_URL = 'http://localhost:5000/api';

export const initiatePayment = async (paymentData) => {
  try {
    const response = await axios.post(`${API_URL}/payments/initiate`, paymentData);
    return response.data;
  } catch (error) {
    console.error('API Error:', error);
    throw error.response?.data || { success: false, message: 'Network error' };
  }
};